var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttahcment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.019,
    height: 18.521,
    viewBox: "0 0 21.019 18.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attahcment",
    transform: "translate(-2.75 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attachment"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3322",
    "data-name": "Group 3322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11466",
    "data-name": "Path 11466",
    d: "M18.645,33.045a6.406,6.406,0,0,0-9.049,0l-8.29,8.29a4.466,4.466,0,0,0,6.316,6.316l8.29-8.29a2.534,2.534,0,1,0-3.583-3.583L5.4,42.7a.6.6,0,1,0,.85.85l6.924-6.924a1.331,1.331,0,0,1,1.883,1.883L6.772,46.8a3.264,3.264,0,0,1-4.616-4.616l8.29-8.29a5.2,5.2,0,1,1,7.349,7.349l-6.924,6.924a.6.6,0,1,0,.85.85l6.924-6.924a6.4,6.4,0,0,0,0-9.049Z",
    transform: "translate(3 -31.174)",
    fill: "#882474",
    stroke: "#882474",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttahcment);
export default __webpack_public_path__ + "static/media/attahcment.ed1ab7ae00751297c73a8694ac9527de.svg";
export { ForwardRef as ReactComponent };